// extracted by mini-css-extract-plugin
module.exports = {"Container":"member-operations__ActivityLog__Container","Container__iframe":"member-operations__ActivityLog__Container__iframe"};